import md5 from "md5"
import moment from "moment"
import axios from "axios"
import VS2 from "vue-script2"
import axiosAuthRequired from "./axiosAuthRequired"
import { get } from "lodash"
const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

const getAuthHeaders = () => {
  let headers = {}
  let clientCredentials = window.localStorage.getItem("client_credentials")
  if (clientCredentials) {
    headers["Authorization"] = "Bearer " + clientCredentials
  }

  return headers
}

const signJWP = (path, timeout, secret, domain) => {
  let expires
  if (timeout) {
    expires = moment().format("X") + timeout
  } else {
    expires = moment().format("X") + 30
  }
  let signature = md5(path + ":" + expires + ":" + secret)
  let url =
    "https://" + domain + "/" + path + "?exp=" + expires + "&sig=" + signature
  return url
}

export const loadJWP = () => {
  // const JWP_CDN = 'https://cdn.jwplayer.com/'
  const JWP_VIDEO_EXPIRY = 1800 // 30 minutes
  const JWP_PLAYER_COURSE = "ufTLZjd2"
  // const JWP_KEY = 'WTDMRHNQ'
  const JWP_SECRET = "4lWbSzPHklCJlN3iTkkFjvkO"
  let url = signJWP(
    "libraries/" + JWP_PLAYER_COURSE + ".js",
    JWP_VIDEO_EXPIRY,
    JWP_SECRET,
    "cdn.jwplayer.com"
  )
  return VS2.load(url)
    .then(() => {
      return "success"
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const loadBlogJWP = () => {
  return axios({
    method: "get",
    url: "/api/v2/services/jwplayer/player/blog",
  }).then(response => {
    return VS2.load(response.data)
      .then(() => {
        return "success"
      })
      .catch(error => {
        return Promise.reject(error)
      })
  })
}

export const fetchContentfulJWPVideo = contentId => {
  return axiosAuthRequired({
    method: "get",
    url:
      PROGUIDES_WEB_URL +
      "api/v2/services/jwplayer/video?content_type=contentful_entry&content_id=" +
      contentId,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response
    })
    .catch(error => {
      Promise.reject(error)
    })
}

export const fetchVideoFromJWplayer = async contentId => {
  try {
    const url = `https://cdn.jwplayer.com/v2/media/${contentId}`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/api/jwplayer.js